export const GLOBAL_TRACK_ORDER = 'global.trackOrder';

const ResendOrderFormabels = {
  global: {
    trackOrder: {
      lbl_resend_email_modal_heading: 'Resend Confirmation',
      lbl_resend_email_modal_description: 'Enter email address to send confirmation',
      lbl_resend_noEmail_modal_description:
        'The confirmation email will be resent to the email address associated to your order.',
      lbl_resend_email_send_button: 'Send Email',
    },
  },
};

export default ResendOrderFormabels;
